export function hasChangesAvailability(oldAvailability, newAvailability) {
  const normalize = (availability) => ({
    availableInAllCountries: availability?.availableInAllCountries ?? true,
    allowedCountriesIds: Array.isArray(availability?.allowedCountriesIds)
      ? availability.allowedCountriesIds
      : [],
    disallowedCountriesIds: Array.isArray(availability?.disallowedCountriesIds)
      ? availability.disallowedCountriesIds
      : [],
  });

  const oldNormalized = normalize(oldAvailability);
  const newNormalized = normalize(newAvailability);

  // Проверка булевого значения
  if (
    oldNormalized.availableInAllCountries !== newNormalized.availableInAllCountries
  ) {
    console.log('change boolean');
    return true;
  }

  // Проверка массивов allowedCountriesIds
  const oldAllowed = new Set(oldNormalized.allowedCountriesIds.map(Number));
  const newAllowed = new Set(newNormalized.allowedCountriesIds.map(Number));

  if (
    [...newAllowed].some((id) => !oldAllowed.has(id)) || // Есть добавленные элементы
    [...oldAllowed].some((id) => !newAllowed.has(id)) // Есть удаленные элементы
  ) {
    console.log('change allow', newAllowed, oldAllowed);
    return true;
  }

  const oldDisallowed = new Set(oldNormalized.disallowedCountriesIds.map(Number));
  const newDisallowed = new Set(newNormalized.disallowedCountriesIds.map(Number));

  if (
    [...newDisallowed].some((id) => !oldDisallowed.has(id)) || // Есть добавленные элементы
    [...oldDisallowed].some((id) => !newDisallowed.has(id)) // Есть удаленные элементы
  ) {
    console.log('change disallow');
    return true;
  }

  return false;
}
